import { IPixelCustomDataParameters } from '@faire/web-api--source/indigofair/data/IPixelCustomDataParameters';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'signup-sign_up_form_step_1_basic_info-view';

/**
 * User view the sign up form step 1
 */
export function trackSignupSignUpFormStep1BasicInfoView(
  pixelCustomDataParams?: IPixelCustomDataParameters
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    facebookPixelEvent: 'sign-up-form-step-1-basic-info',
    googleTagManagerEvent: 'sign-up-form-step-1-basic-info',
    pixelCustomDataParams,
  });
}
